import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardActionArea, Typography } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import usePageTitle from '../shared/hooks/usePageTitle';

export default function RegistrationLanding() {
  usePageTitle('OSSDF Registration');
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        p: 4,
        bgcolor: 'background.default',
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
          OSSDF School Account Registration
        </Typography>
      </Box>


      <Card elevation={2}>
        <CardActionArea
          onClick={() => navigate('/registration/school')}
          sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, textAlign: 'center' }}
        >
          <SchoolIcon color="primary" sx={{ fontSize: 52 }} />
          <Box>
            <Typography variant="h6" fontWeight={600}>School Account Registration</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              For teachers to register and manage their school account, including school information, teachers, dancers, and event registration.
            </Typography>
            <Typography variant="body2" color="text.secondary" fontStyle={'italic'} sx={{ mt: 0.5 }}>
              Please note, this does not register you for the event itself. Event registration is a separate process.
            </Typography>
          </Box>
        </CardActionArea>
      </Card>
    </Box>
  );
}
